import Swiper, { Navigation, Pagination, EffectFade, Scrollbar } from "swiper";

export class HomePage {
  constructor() {

    //chips expand
    const btnChipContainer: HTMLDivElement = document.querySelector<HTMLDivElement>('.button-chip-container');

    if (btnChipContainer) {

      const seeBtn: HTMLDivElement = document.querySelector<HTMLDivElement>('#seeBtn');
      if (btnChipContainer.scrollHeight > btnChipContainer.offsetHeight) {
        console.log("not overflowing");
        seeBtn.classList.remove('d-none');
        seeBtn.classList.remove('invisible');
      } else {
        console.log("overflowing")
        seeBtn.classList.add('d-none');
        seeBtn.classList.add('invisible');

      }
      let btnClicked: boolean = false;

      const toggleBtnClicked = () => {
        btnClicked = !btnClicked;
        seeBtn.innerHTML = btnClicked ? "Vedi di meno" : "Vedi di più";
        btnChipContainer.classList.toggle("showall");
      }
      seeBtn?.addEventListener("click", toggleBtnClicked);

    }


    const slidesTitlesHtml = document.querySelectorAll<HTMLElement>(".slideTitle");
    console.log(slidesTitlesHtml);

    if (slidesTitlesHtml?.length > 0) {
      const slidesTitle: string[] = [
      ];
      slidesTitlesHtml.forEach(res=>{
          slidesTitle.push(res.innerHTML);
      })


      const processSwiper = new Swiper(".homepage-swiper", {
        effect: "fade",
        allowTouchMove: true,
        modules: [Navigation, Pagination, EffectFade, Scrollbar],

        scrollbar: {
          enabled: true,
          el: ".swiper-scrollbar-home",
          hide: false,
          draggable: true,
          dragSize: "auto",
        },
        navigation: {
          nextEl: ".process-button-next",
          prevEl: ".process-button-prev",
        },
        pagination: {
          el: ".process-pagination",
          clickable: true,
          type: "custom",
          renderCustom: function (swiper, current, total) {
            // cerco chi ha la classe active
            const currentTitle =
              document.getElementsByClassName("activeTitle")[0];

            for (let index = 0; index < slidesTitlesHtml.length; index++) {
              slidesTitlesHtml[index].addEventListener("click", () => {
                processSwiper.slideTo(index);

                if (currentTitle) {
                  // e la tolgo
                  currentTitle.classList.remove("activeTitle");
                }

                // al click aggiungo la classe active sul titolo cliccato
                slidesTitlesHtml[index].classList.add("activeTitle");
              });
            }

            if (currentTitle) {
              currentTitle.classList.remove("activeTitle");
            }

            // al click aggiungo la classe active sul titolo cliccato
            slidesTitlesHtml[current - 1].classList.add("activeTitle");
            return slidesTitle[current - 1];
          },
        },

        breakpoints: {
          768: {
            direction: "vertical",
            allowTouchMove: false,
          },
        },
      });
    }
  }
}
